import type { ObjectValues } from "@/src/shared/types/objectValues";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_ACCORDION_SIZE = {
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
} as const;

export type DSAccordionSize = ObjectValues<typeof DS_ACCORDION_SIZE>;
